// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3JWRd","name":"Header_name__1C53j","birthday":"Header_birthday__3odI7","skeleton":"Header_skeleton__2LKX_"};